// Shared bingo cell visual constants.
// CELL_STATE holds colors/borders for each state — no sizing.
// Each page spreads these and adds its own layout/sizing props.

export const CELL_STATE = {
  default: {
    backgroundColor: '#EDF6F9',
    color: '#4a5568',
  },
  marked: {
    backgroundColor: 'rgba(131,197,190,0.25)',
    border: '1.5px solid rgba(131,197,190,0.5)',
    color: '#fff',
  },
  called: {
    backgroundColor: '#83C5BE',
    color: '#004f58',
    fontWeight: '700',
  },
  free: {
    backgroundColor: '#FF6B6B',
    color: '#fff',
    fontWeight: '800',
  },
};

// Full style objects for non-playable preview cards (LandingPage).
const PREVIEW_LAYOUT = {
  borderRadius: '6px', minHeight: '46px', display: 'flex',
  alignItems: 'center', justifyContent: 'center',
  fontSize: '9px', textAlign: 'center', padding: '4px',
};

export const CELL_STYLES_PREVIEW = {
  default: { ...PREVIEW_LAYOUT, ...CELL_STATE.default },
  marked:  { ...PREVIEW_LAYOUT, ...CELL_STATE.marked },
  called:  { ...PREVIEW_LAYOUT, ...CELL_STATE.called },
  free:    { ...PREVIEW_LAYOUT, ...CELL_STATE.free, textTransform: 'uppercase', letterSpacing: '1px' },
};
